/**
 * Permite links de campaña tipo:
 *   https://inspiraciones.cl/?cart_add=<variant_id>:<qty>&discount=<codigo>
 * Agrega el producto vía AJAX y abre el cart drawer con el descuento ya aplicado,
 * sin pasar por /cart/<id>:<qty> (esa ruta redirige a checkout en esta tienda).
 * No hace nada si no viene el parámetro cart_add.
 */
(function () {
  var params = new URLSearchParams(window.location.search);
  var cartAdd = params.get('cart_add');
  if (!cartAdd) return;

  var variantId = cartAdd.split(':')[0];
  var quantity = parseInt(cartAdd.split(':')[1], 10) || 1;
  var discount = params.get('discount');

  function addToCart() {
    var cartDrawer = document.querySelector('cart-drawer');
    // getSectionsToRender() del custom element devuelve ['cart-drawer',
    // 'cart-icon-bubble']; si aún no estuviera disponible, usamos esa lista fija.
    var sections = (cartDrawer && cartDrawer.getSectionsToRender)
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      : 'cart-drawer,cart-icon-bubble';

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    formData.append('sections', sections);
    formData.append('sections_url', window.location.pathname);

    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    }).then(function (res) { return res.json(); });
  }

  // El snippet inline cart-link-preload (en el <head>) ya disparó la cadena de
  // red durante el parseo del HTML y dejó el promise en window.__cartLinkReady.
  // Lo reutilizamos para no repetir los fetches. Si por lo que sea no corrió,
  // hacemos la cadena acá como fallback (el descuento va ANTES del add para que
  // la sección renderizada ya traiga el cupón visible; por eso, en secuencia).
  var ready = window.__cartLinkReady;
  if (!ready) {
    ready = (discount
      ? fetch('/discount/' + encodeURIComponent(discount), { redirect: 'manual' }).catch(function () {})
      : Promise.resolve()
    ).then(addToCart);
  }

  // Cuando el carrito parte vacío, <cart-drawer> nace con clase "is-empty"
  // (component-cart-drawer.css la usa para el layout de "carrito vacío", que
  // colapsa la tabla de items a 0x0). Ni Dawn ni el swap de secciones la
  // sacan del elemento raíz, así que hay que removerla a mano antes de abrir.
  function openDrawerWithData(cartDrawer, data) {
    cartDrawer.classList.remove('is-empty');
    var drawerInner = cartDrawer.querySelector('.drawer__inner');
    if (drawerInner) drawerInner.classList.remove('is-empty');

    cartDrawer.productId = data.id;
    cartDrawer.getSectionsToRender().forEach(function (section) {
      var sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;
      var html = cartDrawer.getSectionInnerHTML(data.sections[section.id], section.selector);
      // La miniatura del item viene con loading="lazy"; dentro del drawer (que
      // arranca con transform fuera de pantalla) iOS Safari no dispara el lazy
      // y la imagen queda en blanco en la primera apertura aunque esté en caché.
      // Forzarla a eager en el HTML antes de insertarla la carga y pinta al abrir.
      if (section.id === 'cart-drawer') {
        html = html.replace(/loading=(["'])lazy\1/g, 'loading="eager"');
      }
      sectionElement.innerHTML = html;
    });

    var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
    cartDrawer.open();
  }

  function finish() {
    ready
      .then(function (data) {
        if (!data || data.status) return;
        var cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;

        // Abrimos apenas resuelve add.js; la miniatura ya va como loading=eager
        // (ver openDrawerWithData) así que carga y se pinta sola sin bloquear.
        openDrawerWithData(cartDrawer, data);

        var url = new URL(window.location.href);
        url.searchParams.delete('cart_add');
        url.searchParams.delete('discount');
        window.history.replaceState({}, '', url);
      })
      .catch(function (e) {
        console.error('cart-link-loader:', e);
      });
  }

  // defer ya garantiza que el DOM está parseado y cart-drawer.js definió el
  // custom element; corremos de inmediato salvo el caso límite 'loading'.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', finish);
  } else {
    finish();
  }
})();
